import templateOnly from '@ember/component/template-only';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if (or (is-array @values) (eq \'select\' @controlType))}}\n  {{#if (has-block)}}\n    <Quill::Toolbar::Select @type={{@type}} ...attributes>{{yield}}</Quill::Toolbar::Select>\n  {{else}}\n    <Quill::Toolbar::Select\n      @selected={{@selected}}\n      @type={{@type}}\n      @values={{@values}}\n      ...attributes\n    />\n  {{/if}}\n{{else}}\n  {{#if (has-block)}}\n    <Quill::Toolbar::Button @type={{@type}} ...attributes>{{yield}}</Quill::Toolbar::Button>\n  {{else}}\n    <Quill::Toolbar::Button @type={{@type}} ...attributes />\n  {{/if}}\n{{/if}}");

var buttonOrSelect = setComponentTemplate(TEMPLATE, templateOnly());

export { buttonOrSelect as default };
//# sourceMappingURL=button-or-select.js.map
